import React from 'react'
import './CardProps.css'
import { useNavigate } from 'react-router-dom'

const CardProps = (props) => {

  const navigate = useNavigate()

  const handleDetails = () => {
    // Navigate to the stock details page and pass the stock details as state
    navigate('/stock-details', {state: {companyName: props.Stock_Name, 
      StockPrice: props.price,
      componentColor: props.textColor
    }});
   }

   console.log(props.Stock_Name)

  return (
    <div className="Price-Evaluation-Card m-2 p-2 my-3" key={props.index}>
      <i className="stock-price py-1" style={{fontWeight:'lighter'}}>Date:  {props.from_date}  to  {props.to_date}</i>
    <img src={props.market_logo} className="Price-Evaluation-img" alt="Raise/Fall Market logo" />
    



    <div className="Price-Evaluation-inner my-1">

      <div className='Price-Evaluation-text'>
      <h5 className="stock-title" style={{fontWeight:'bold'}}>{props.Stock_Name}</h5>
        
        <p className="stock-price">₹{props.price}/-</p>
        
        <button className="btn btn-primary" onClick={handleDetails}>Reason</button>
      </div>

      <div className="Price-Evaluation-arrow">
      <p className="stock-price" style={{color:`${props.textColor}`, fontWeight:'bold'}}>{props.percentage_difference}%</p>
        <img src={props.Arrow} alt='Arrow up/down'/>
      </div>
    </div>
  </div>
  )
}

export default CardProps
